export default "__VITE_ASSET__C7nHJXV1__"